// src/pages/ItensMenu.js
import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { FaChevronRight, FaRotateRight } from "react-icons/fa6";
import { useApi } from "../hooks/useApi";
import Header from "../components/Form/Header";
import MainContent from "../components/Form/MainContent";
import './ItensMenu.css';  // Importar o arquivo CSS externo.
import { formatCurrency } from "../utils/numberUtils";
import { getCashBackPercent, resolveCashBackPercent } from "../utils/cashBackUtils";
import FooterCart from "../components/Form/FooterCart";
import { applyImageFallback } from "../utils/imageUtils";



const ItensMenu = () => {  
  const { groupId } = useParams();
  const location = useLocation();
  const group = location.state?.group;
  const groupName = group?.descricao || "Itens";

  const { buildApiUrl, fetchData } = useApi();
  const navigate = useNavigate();
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cashBackPercent, setCashBackPercent] = useState(0);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    // Função para buscar dados da API
    const fetchDataFromAPI = async () => {
      setLoading(true);
      setError(null);
      try {
        //console.log(groupId);
        
        const [result, configResult] = await Promise.all([
          fetchData('/ProdutoDelivery/ProdutosByGrupo', 
            { grupoId: groupId } // Passa o grupoId como parâmetro
          ),
          fetchData('/ConfigPedido')
        ]);

        // Ajuste o estado dos dados recebidos da API
        setItens(Array.isArray(result) ? result : []);
        setCashBackPercent(getCashBackPercent(configResult));
        setLoading(false);
      } catch (error) {
        setError("Não foi possível carregar os produtos desta categoria.");
        setLoading(false);
      }
    };

    fetchDataFromAPI();
  }, [groupId, reloadKey]);

  // 🔥 O navegador dispara o download binário somente quando cada imagem é renderizada.
  const handleItemClick = (itemSel) => {
    navigate(`/itemdetails/${itemSel.id}`, { state: { itemSel, group } });
  };

  const getItemCashBackPercent = (item) => {
    return resolveCashBackPercent({ cashBackPercent }, group, item);
  };

  return (
    <>
      <Header urlBack="/ordermenu" titulo={groupName} /> {/* Altere para usar o nome do grupo que foi definido */}

      <MainContent className="itens-menu-main">
        <section className="itens-menu-page" aria-labelledby="itens-menu-heading">
          <div className="itens-menu-heading">
            <div>
              <span>Explore o cardápio</span>
              <h2 id="itens-menu-heading">Escolha seu pedido</h2>
            </div>
            {!loading && !error && (
              <p>{itens.length} {itens.length === 1 ? 'item' : 'itens'}</p>
            )}
          </div>

          {loading && (
            <div className="itens-menu-grid" aria-label="Carregando produtos" aria-busy="true">
              {[1, 2, 3, 4, 5, 6].map((item) => (
                <div key={item} className="itens-menu-skeleton" aria-hidden="true" />
              ))}
            </div>
          )}

          {!loading && error && (
            <div className="itens-menu-feedback" role="alert">
              <p>{error}</p>
              <button type="button" onClick={() => setReloadKey((currentKey) => currentKey + 1)}>
                <FaRotateRight aria-hidden="true" />
                Tentar novamente
              </button>
            </div>
          )}

          {!loading && !error && itens.length === 0 && (
            <div className="itens-menu-feedback">
              <p>Nenhum produto disponível nesta categoria no momento.</p>
            </div>
          )}

          {!loading && !error && itens.length > 0 && (
            <div className="itens-menu-grid">
              {itens.map((item) => {
                const itemCashBackPercent = getItemCashBackPercent(item);

                return (
                  <button
                    key={item.id}
                    type="button"
                    className={`itens-menu-card ${item.esgotado ? "is-sold-out" : ""}`}
                    onClick={() => handleItemClick(item)}
                    disabled={Boolean(item.esgotado)}
                  >
                    <span className="itens-menu-image-wrapper">
                      <img
                        src={item.imagemId
                          ? buildApiUrl('/ProdutoDelivery/ProdutoImagemArquivo', { produtoId: item.id })
                          : "/images/image_default.jpg"}
                        alt={item.descricao || 'Produto'}
                        className="itens-menu-image"
                        loading="lazy"
                        onError={applyImageFallback}
                      />
                      {item.esgotado && <span className="itens-menu-sold-out">Esgotado</span>}
                    </span>

                    <span className="itens-menu-info">
                      <strong className="itens-menu-name">{item.descricao}</strong>
                      {item.ingredientes && (
                        <span className="itens-menu-description">{item.ingredientes}</span>
                      )}
                      <span className="itens-menu-card-footer">
                        <span>
                          <span className="itens-menu-price">{formatCurrency(item.preco)}</span>
                          {itemCashBackPercent > 0 && (
                            <span className="itens-menu-cashback">
                              {itemCashBackPercent}% cashback
                            </span>
                          )}
                        </span>
                        <FaChevronRight className="itens-menu-chevron" aria-hidden="true" />
                      </span>
                    </span>
                  </button>
                );
              })}
            </div>
          )}
        </section>
      </MainContent>

      <FooterCart />
    </>
  );
};

export default ItensMenu;
